// We manually created our own browser history to enable programmatic redirection from within ACs

import { createBrowserHistory } from 'history';
export default createBrowserHistory();
